import { blue } from '@material-ui/core/colors';
import { rgba } from 'polished';

export default {
  spacing: 4,
  palette: {
    // common: {
    //   black: '#000',
    //   white: '#fff'
    // },
    type: 'light',
    primary: {
      light: blue[200],
      main: blue[500],
      dark: blue[800],
      contrastText: '#fff' // '#474747'
    },
    secondary: {
      light: '#ff4081',
      main: '#f50057',
      dark: '#c51162',
      contrastText: '#fff'
    },
    // error: {
    //   light: '#e57373',
    //   main: '#f44336',
    //   dark: '#d32f2f',
    //   contrastText: '#fff'
    // },
    // warning: {
    //   light: '#ffb74d',
    //   main: '#ff9800',
    //   dark: '#f57c00',
    //   contrastText: '#474747'
    // },
    // info: {
    //   light: '#64b5f6',
    //   main: '#2196f3',
    //   dark: '#1976d2',
    //   contrastText: '#fff'
    // },
    // success: {
    //   light: '#81c782',
    //   main: '#4caf50',
    //   dark: '#388e3c',
    //   contrastText: '#474747'
    // },
    // grey: {
    //   50: '#fafafa',
    //   100: '#f5f5f5',
    //   200: '#eeeeee',
    //   300: '#e0e0e0',
    //   400: '#bdbdbd',
    //   500: '#9e9e9e',
    //   600: '#757575',
    //   700: '#616161',
    //   800: '#424242',
    //   900: '#212121',
    //   A100: '#d5d5d5',
    //   A200: '#aaaaaa',
    //   A400: '#303030',
    //   A700: '#616161'
    // },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    // text: {
    //   primary: '#474747',
    //   secondary: rgba(0, 0, 0, 0.54),
    //   disable: rgba(0, 0, 0, 0.38),
    //   hint: rgba(0, 0, 0, 0.38)
    // },
    // divider: rgba(0, 0, 0, 0.12),
    // background: {
    //   paper: '#fff',
    //   default: '#fafafa'
    // },
    action: {
      active: rgba(0, 0, 0, 0.54),
      hover: rgba(0, 0, 0, 0.04),
      hoverOpacity: 0.04,
      selected: rgba(0, 0, 0, 0.08),
      selectedOpacity: 0.08,
      disabled: rgba(0, 0, 0, 0.26),
      disabledBackground: rgba(0, 0, 0, 0.12),
      disabledOpacity: 0.38,
      focus: rgba(0, 0, 0, 0.12),
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    },
    product: {
      unlimited: {
        light: '#33eb91',
        main: '#00e676',
        dark: '#00a152',
        textContrast: '#474747'
      },
      single: {
        light: blue[200],
        main: blue[500],
        dark: blue[800],
        contrastText: '#474747'
      },
      zero: {
        light: '#ff4081',
        main: '#f50057',
        dark: '#c51162',
        contrastText: '#474747'
      }
    },
    eventCategory: {
      one: blue[300],
      two: blue[400],
      three: blue[500],
      four: blue[600],
      five: blue[800],
      other: blue[300]
    }
  },
  shape: {
    borderRadius: 4
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontSize: '3rem'
    },
    h2: {
      fontSize: '2rem'
    },
    h3: {
      fontSize: '1.75rem'
    },
    h4: {
      fontSize: '1.5rem'
    },
    h5: {
      fontSize: '1.25rem'
    },
    h6: {
      fontSize: '1rem'
    },
    subtitle1: {
      fontSize: '1.1rem'
    },
    subtitle2: {
      fontSize: '0.875rem'
    },
    body1: {
      fontSize: '1rem'
    },
    body2: {
      fontSize: '0.875rem'
    }
  }
};
